import { render, staticRenderFns } from "./ContactReferralPartner.vue?vue&type=template&id=0a76c452&scoped=true"
import script from "./ContactReferralPartner.vue?vue&type=script&lang=js"
export * from "./ContactReferralPartner.vue?vue&type=script&lang=js"
import style0 from "./ContactReferralPartner.vue?vue&type=style&index=0&id=0a76c452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a76c452",
  null
  
)

export default component.exports